import React, {useState} from "react";
import I18n from 'i18n.js.erb'
import {downloadServerPdf, isPresent} from "../../utils/utils";

// Pulsante (o link, o componente qualsiasi) che scarica un pdf generato dal server (Prawn) all'url pdfUrl
const PDFGenerator = ({
  type,
  generatorText,
  cssClassList,
  pdfUrl,
  setShowErrorModal,
  customIcon,
  customImageIcon,
  spinnerCssClassList,
  downloadMsgCssClassList,
  customComponentToRender,
  customComponentToRenderCssClass
}) => {

  const [loading, setLoading] = useState(false);



  // Funzione che scarica un pdf generato dal server (Prawn)
  const downloadServerPDFFile = () => {
    setLoading(true);

    downloadServerPdf(pdfUrl)
      .then(() => setLoading(false))
      .catch((err) => {
        if (setShowErrorModal)
          setShowErrorModal(true)
        console.log(err);
        setLoading(false)
      });
  }



  return (
    customComponentToRender ?
      <div className={isPresent(customComponentToRenderCssClass) ? customComponentToRenderCssClass : 'text-truncate'}
           onClick={(e) => {
             e.stopPropagation();
             downloadServerPDFFile();
           }}>
        {customComponentToRender}
      </div>
    :
      (
        type === 'button' ?
          <React.Fragment>
            {
              loading ?
                <div className={cssClassList}>
                  <div className="d-flex align-items-center text-center">
                    <div className={`spinner-border text-white ml-4 ${spinnerCssClassList ? spinnerCssClassList : ''}`} role="status"/>
                    <p className={`ml-2 text-nowrap text-white mb-0 ${downloadMsgCssClassList ? downloadMsgCssClassList : ''}`}>{I18n.t('js.PDFGenerator.submissionList.loadingData')}</p>
                  </div>
                </div>
              :
                <button
                  type="button"
                  className={cssClassList}
                  onClick={downloadServerPDFFile}
                >
                  {
                    customImageIcon ?
                      <img src={customImageIcon} alt="" />
                    :
                      <i className={customIcon ? customIcon : "fas fa-file-download fa-lg"}/>
                  } &nbsp;
                  {generatorText}
                </button>
            }
          </React.Fragment>
        :
          <span
            className="text-aiBlue text-underline-imp cursor-pointer"
            onClick={downloadServerPDFFile}
          >
            {generatorText}
          </span>
      )
    )
}

export default PDFGenerator;
